import {AssigneeDetails, OrderHistory} from '@buncha/B2B/hooks/type';
import {Box, CenterBox} from '@buncha/components/core/view';
import {CustomText, H5Text} from '@buncha/components/core/text';
import React, {useEffect} from 'react';
import {useColorThemeType, useFontTheme} from '@buncha/appStyles/hooks/theme';

import {B2BUserScreens} from '@buncha/B2B/navigation/types';
import ContactShopperButton from '../contactShopperButton/ContactShopperButton';
import If from '@buncha/components/conditional/If';
import {Modules} from '@buncha/utils/types';
import ShopperProfileImage from '../shopperProfileImage/ShopperProfileImage';
import StepHeader from '../stepHeader/StepHeader';
import ViewOrderItemButton from '../viewOrderItemButton/ViewOrderItemButton';
import moment from 'moment';
import {styles} from './styles';
import {useAppSelector} from '@buncha/config/redux/hooks';
import {useGetLocale} from '@buncha/localization/hooks';

interface ShoppingStepProps {
  isActive: boolean;
  assigneeDetails?: AssigneeDetails;
  orderId: string;
  orderHistory?: OrderHistory;
  setScreenTitle?: React.Dispatch<React.SetStateAction<string>>;
  runId: number;
  legacyId: number;
}

const ShoppingStep: React.FC<ShoppingStepProps> = props => {
  const {
    isActive,
    assigneeDetails,
    orderId,
    orderHistory,
    setScreenTitle,
    runId,
    legacyId,
  } = props;
  const muliFont = useFontTheme();
  const theme = useColorThemeType();
  const {title, body} =
    useGetLocale(Modules.B2BUserOrder, B2BUserScreens.OrderInfo) ?? {};
  const callDisabledUserIds: number[] = JSON.parse(
    useAppSelector(
      gState => gState.onboarding.constants?.CALL_DISABLED_USER_IDS,
    ) ?? '[]',
  );
  const timeStamp = orderHistory?.createdAt.length
    ? moment(orderHistory?.createdAt).format('hh:mm a')
    : '';

  useEffect(() => {
    if (isActive && setScreenTitle)
      setScreenTitle(title?.shoppingInProgress || '');
  }, [isActive, setScreenTitle, title?.shoppingInProgress]);

  return (
    <Box>
      <StepHeader
        textTitle={title?.shoppingInProgress}
        timeString={timeStamp}
      />
      <If condition={isActive}>
        <CenterBox style={styles.centerBox}>
          <ShopperProfileImage
            imageWidth={110}
            imageHeight={110}
            assigneeId={assigneeDetails?.id ?? ''}
            isShopper={true}
            imageUrl={assigneeDetails?.imageUrl}
            phoneNumber={assigneeDetails?.phone ?? ''}
          />

          <H5Text
            style={[
              styles.shopperName,
              {
                color: theme?.text.blue[300],
                fontFamily: muliFont[700].normal,
              },
            ]}>
            {assigneeDetails?.name}
            <H5Text
              style={{
                color: theme?.text.blue[300],
                fontFamily: muliFont[400].normal,
              }}>
              {body?.shoppingFor}
            </H5Text>
          </H5Text>

          <CustomText style={styles.infoText}>{body?.makeChanges}</CustomText>

          <Box style={styles.buttonContainer}>
            <ViewOrderItemButton
              orderId={orderId}
              runId={runId}
              legacyId={legacyId}
            />
            <If
              condition={
                !callDisabledUserIds?.includes(
                  Number(assigneeDetails?.id ?? '0'),
                )
              }>
              <ContactShopperButton
                id={assigneeDetails?.id || ''}
                name={assigneeDetails?.name || ''}
                phoneNumber={assigneeDetails?.phone}
                isShopper
              />
            </If>
          </Box>
        </CenterBox>
      </If>
    </Box>
  );
};

export default React.memo(ShoppingStep);
